declare global {
  interface Window {
    Telegram?: {
      WebApp: TelegramWebApp
    }
  }
}

export interface TelegramWebApp {
  initData: string
  initDataUnsafe: Record<string, unknown>
  version: string
  platform: string
  colorScheme: 'light' | 'dark'
  themeParams: Record<string, string>
  isExpanded: boolean
  viewportHeight: number
  viewportStableHeight: number
  ready(): void
  expand(): void
  close(): void
  setHeaderColor(color: string): void
  setBackgroundColor(color: string): void
}

export function isTelegramWebApp(): boolean {
  return typeof window !== 'undefined' && !!window.Telegram?.WebApp?.initData
}

export function getTelegramWebApp(): TelegramWebApp | null {
  return window.Telegram?.WebApp ?? null
}

export function initTelegramWebAppChrome(): void {
  const tg = getTelegramWebApp()
  if (!tg) return
  tg.ready()
  tg.expand()
  const bg = '#f3f4f9'
  tg.setBackgroundColor(bg)
  tg.setHeaderColor('#ffffff')
  document.documentElement.classList.add('tg-webapp')
  document.body.style.backgroundColor = bg
}
